import React from 'react'
import PropTypes from 'prop-types'

import { RuleRunner, run } from 'Pods/Shared/RuleRunner'
import { required } from 'Pods/Shared/Rules/Rules'

import UserAvatar from 'Pods/Shared/UserAvatar/UserAvatar'
import TextareaField from 'Pods/Shared/TextareaField'

const fieldValidations = [
  RuleRunner('content', 'Content', required),
]

class Comment extends React.Component {
  constructor() {
    super()

    this.state = {
      commentFormVisible: false,
      showErrors: false,
      disableButton: false,
      comment: { content: '', id: null, parentId: null },
    }

    this.removeComment = this.removeComment.bind(this)
    this.editComment = this.editComment.bind(this)
    this.replyComment = this.replyComment.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleUpdate = this.handleUpdate.bind(this)
    this.onSubmitSuccess = this.onSubmitSuccess.bind(this)
    this.onSubmitFailure = this.onSubmitFailure.bind(this)
  }

  componentDidMount() {
    this.setState({ validationErrors: run(this.state.comment, fieldValidations) })
  }

  removeComment() {
    this.props.removeComment(this.props.comment.id)
  }

  errorFor(field) {
    if (this.state.validationErrors) {
      return this.state.validationErrors[field] || ''
    }
  }

  editComment() {
    const newState = this.state

    newState.comment.content = this.props.comment.content
    newState.comment.id = this.props.comment.id
    newState.commentFormVisible = true

    this.setState(newState)
  }

  replyComment() {
    if (this.props.isSignedIn) {
      const newState = this.state

      newState.commentFormVisible = true
      newState.comment.parentId = this.props.comment.id

      this.setState(newState)
    } else {
      App.events.publish('app:login:open')
    }
  }

  handleInputChange(event) {
    const newState = this.state

    newState.comment.content = event.target.value
    newState.validationErrors = run(newState.comment, fieldValidations)

    this.setState({ newState })
  }

  handleSubmit(event) {
    event.preventDefault()

    if (this.state.comment.id) {
      this.handleUpdate()
    } else {
      this.setState({
        showErrors: true,
        disableButton: true,
        validationErrors: run(this.state.comment, fieldValidations),
      })

      if (this.props.isSignedIn) {
        if (Object.getOwnPropertyNames(this.state.validationErrors).length === 0) {
          axios.post('/api/internal/comments',
            {
              commentable_type: 'Item',
              commentable_id: this.props.itemId,
              content: this.state.comment.content,
              parent_id: this.state.comment.parentId,
            }).then(this.onSubmitSuccess).catch(this.onSubmitFailure)
        } else {
          this.setState({ disableButton: false })
        }
      } else {
        App.events.publish('app:login:open')
      }
    }
  }

  handleUpdate() {
    this.setState({
      showErrors: true,
      disableButton: true,
      validationErrors: run(this.state.comment, fieldValidations),
    })

    if (Object.getOwnPropertyNames(this.state.validationErrors).length === 0) {
      axios.put(`/api/internal/comments/${this.state.comment.id}`,
        {
          commentable_type: 'Item',
          commentable_id: this.props.itemId,
          content: this.state.comment.content,
          parent_id: this.state.comment.parentId,
        }).then(this.onSubmitSuccess).catch(this.onSubmitFailure)
    } else {
      this.setState({ disableButton: false })
    }
  }

  onSubmitFailure(xhr) {
    App.events.publish('app:notification:flash:error', xhr.response.data.errors[0].detail)

    this.setState({ disableButton: false })
  }

  onSubmitSuccess() {
    const newState = this.state

    newState.comment = { content: '', id: null, parentId: null }
    newState.commentFormVisible = false

    this.setState(newState)

    this.props.onPaginate(this.props.currentPage)
  }

  render() {
    return (
      <li>
        <div className="project-comment__author">
          <a href={`/designers/${this.props.comment.author.username}`} className="author-link">
            <UserAvatar
              img={this.props.comment.author.avatarUrl}
              userName={this.props.comment.author.username}
              size="small"
              isWithName
            />
          </a>
          <div className="labels-list">
            {this.props.comment.author.isAuthor && <div className="label label--author">Author</div>}
            {this.props.comment.author.isBuyer && <div className="label">Buyer</div>}
          </div>
          <div className="project-comment__date">{this.props.comment.createdAt}</div>
        </div>
        <div className="card card--flat">
          {this.props.comment.content}

          <div className="project-comment__actions-bar">
            {this.props.currentUserId === this.props.comment.author.id ? (
              <a className="project-comment__action" onClick={(e) => this.editComment(e)}>
                Edit
              </a>
            ) : (
              <a className="project-comment__action" onClick={(e) => this.replyComment(e)}>
                Reply
              </a>
            )}
            {(this.props.currentUserId === this.props.comment.author.id || this.props.isAdmin) && (
              <a className="project-comment__action" onClick={(e) => this.removeComment(e)}>
                Delete
              </a>
            )}
          </div>
          {this.state.commentFormVisible
            && (
            <form className="comment-form u-mt10" onSubmit={this.handleSubmit}>
              <TextareaField
                label="Your comment"
                required
                id="content"
                name="content"
                errorText={this.errorFor('content')}
                showError={this.state.showErrors}
                value={this.state.comment.content}
                formClassName="form-group-grey"
                inputClassName="form-control-grey"
                onChange={this.handleInputChange}
              />
              <div className="u-text-right">
                <button className="btn btn-primary">Submit</button>
              </div>
            </form>
            )
          }
        </div>
        <ul className={this.props.depth < 3 ? 'project-comment__stacked' : ''}>
          {this.props.comment.children.data.map((comment) => (
            <Comment
              comment={comment.attributes}
              children={comment.attributes.children.data}
              key={comment.id}
              removeComment={this.props.removeComment}
              isAdmin={this.props.isAdmin}
              onPaginate={this.props.onPaginate}
              currentPage={this.props.currentPage}
              isSignedIn={this.props.isSignedIn}
              viewerId={this.props.currentUserId}
              itemId={this.props.itemId}
              depth={this.props.depth + 1}
            />
          ))}
        </ul>
      </li>
    )
  }
}

Comment.propTypes = {
  comment: PropTypes.object.isRequired,
  removeComment: PropTypes.func.isRequired,
  onPaginate: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  currentUserId: PropTypes.number,
  currentPage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  isSignedIn: PropTypes.bool.isRequired,
  itemId: PropTypes.number.isRequired,
  children: PropTypes.array,
  depth: PropTypes.number.isRequired,
}

Comment.defaultProps = {
  children: [],
  currentUserId: null,
}

export default Comment
